let ApexCharts = require('apexcharts')
import {formatBytes} from "../util/format-bytes";
$(function () {
    $('[data-chart-load]').each(function () {
        var self = $(this);
        var url = self.data('chart-load');
        let chartOptions = {
            chart: {
                height: self.data('chart-height') ?? 350,
                type: 'line',
            },
            dataLabels: {
                enabled: false
            },
            series: [],
            title: {
                text: self.data('chart-title'),
            },
            noData: {
                text: self.data('chart-loading')
            },
            xaxis: {
                type: "datetime",
            },
            yaxis: {
                labels: {
                }
            },
            tooltip: {
                shared: true
            }
        };
        var yaxisType = self.data('chart-y-axis')
        if (yaxisType === 'bytes') {
            chartOptions.yaxis.labels.formatter = function(val, index) {
                return formatBytes(val);
            }
        }
        var chart = new ApexCharts(self[0], chartOptions);
        chart.render();
        $.getJSON(url, function(res) {
            chart.updateSeries(res)
        }).fail(function () {

        });
    });
})
